import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { CategoriaParceiro } from "../typings";
import http from "infra/http";

export function useCategoriaParceiro() {
    return useQuery<CategoriaParceiro[], AxiosError>(
        `/v1/categoria-parceiro`,

        async () => {
            const { data } = await http.get<CategoriaParceiro[]>("/v1/categoria-parceiro",);

            return data;
        }
    );
}
